// const baseURL = 'http://localhost:8080/api';
// export const baseSoundURL = 'http://localhost:8080';
import { baseURL } from "../config";

//todo add terminalToken in Enum

// Notifying operators that a client is waiting in a queue
export const isNotificationEnabled = true;

// Queue Screen Options. Choose only one of the 2 follow options
export const isQueueTitleEnabled = true;
export const isQueueWeatherForecastEnabled = false;

export const isQueueScreenDarkTheme = true;

export const QueueTitle = "Белинтертранс";
export const QueueSubTitle = "Международные перевозки грузов";

export const isQueueScreenVideoAutoplayEnabled = true;
export const isQueueScreenVideoSoundEnabled = true;
export const videoVolume = 0.1; // from 0 to 1

//Time selector minutes interval settings
export const TimePickerCustomMinutesInterval = 10;

// Terminal Screen Options.
export const isAfterPrintTicketEnabled = false;

export enum StaticTokens {
  monitorToken = "47e662c1-62ce-4a82-9fdd-9f773f0b63e1",
  terminalToken = "239c8f78-5083-4ff5-bd3e-cc7fa701606f",
}

export const AuthorizationAPI = {
  logIn: `${baseURL}/auth/login`,
  logOut: `${baseURL}/auth/logout`,
  getUserWorkplaces: `${baseURL}/auth/user-work-places`,
  putUserAuthInfo: `${baseURL}/auth/user-auth-info`,
};

export const SentryTestAPI = {
  triggerServerError: `${baseURL}/sentry-test`,
};

export const OperatorsAPI = {
  getQueueIn: `${baseURL}/service-units/view`,
  getCarData: (itemId: number) => `${baseURL}/items/${itemId}`,
  getContainersData: (value?: string) => `${baseURL}/containers?name=${value}`,
  getClientsData: (value?: string) => `${baseURL}/clients?name=${value}`,
  updateCarStatus: (id?: number) => `${baseURL}/items/${id}`,
  redirectCarInQueueOut: (id?: number) => `${baseURL}/items/${id}/redirect`,
  addCarInQueue: () => `${baseURL}/items`,
  printEntryTicket: (entryTicketId: number) =>
    `${baseURL}/entry-ticket/${entryTicketId}/print`,
  refreshTicket: () => `${baseURL}/items/refresh`,
  synchronizeDataBase: () => `${baseURL}/synchronization-info`,
};

export const AgentAPI = {
  getAgentQueue: `${baseURL}/service-units/view`,
  changeTicketStatus: `${baseURL}/items`,
};
export const TerminalServicesAPI = {
  getServices: `${baseURL}/order-units/view`,
  getTicketInTerminal: `${baseURL}/items`,
  printTicketInTerminal: (itemId: number) => `${baseURL}/items/${itemId}/print`,
};

export const MonitorQueueAPI = {
  getQueueItems: `${baseURL}/monitor-units/view`,
  getCreatedItems: `${baseURL}/monitor-units/created-items`,
  getQueueTickers: `${baseURL}/monitor-units/tickers`,
  getQueueHeaders: `${baseURL}/monitor-units/texts`,
  getQueueVideoPlaylist: `${baseURL}/monitor-units/playlists`,
  putSoundStatus: (itemId: number) => `${baseURL}/audios/${itemId}`,
};

export const CategoriesTopicsAPI = {
  getCategoriesTopics: `${baseURL}/service-units/operators-topics`,
};

export const RedirectServiceAPI = {
  postRedirectService: (itemId: number) =>
    `${baseURL}/items/${itemId}/redirect`,
};

export const CategoriesTopicsTableAPI = {
  postCreateCategory: `${baseURL}/categories`,
  getAllCategoriesTopics: `${baseURL}/categories-topics/view`,
  getCategoryInfoById: (categoryId: number) =>
    `${baseURL}/categories/${categoryId}`,
  getCategoriesAndTopicsForModal: `${baseURL}/categories-topics`,
  postEditCategory: (categoryId: number) =>
    `${baseURL}/categories/${categoryId}`,
  deleteCategory: (categoryId: number) => `${baseURL}/categories/${categoryId}`,
  activateDeactivateCategory: (categoryId: number) =>
    `${baseURL}/categories/${categoryId}/activate`,
  postCreateTopic: `${baseURL}/topics`,
  postEditTopic: (topicId: number) => `${baseURL}/topics/${topicId}`,
  deleteTopic: (topicId: number) => `${baseURL}/topics/${topicId}`,
  activateDeactivateTopic: (topicId: number) =>
    `${baseURL}/topics/${topicId}/activate`,
  uploadPendingCategoryIcon: `${baseURL}/categories/icons`,
  uploadCategoryIcon: (categoryId: number) =>
    `${baseURL}/categories/${categoryId}/icon`,
  deleteCategoryIcon: (categoryId: number) =>
    `${baseURL}/categories/${categoryId}/icon`,
  uploadPendingCategoryChildrenIcon: `${baseURL}/categories/icons/children`,
  uploadCategoryChildrenIcon: (categoryId: number) =>
    `${baseURL}/categories/${categoryId}/children-icon`,
  deleteCategoryChildrenIcon: (categoryId: number) =>
    `${baseURL}/categories/${categoryId}/children-icon`,
  uploadPendingTopicIcon: `${baseURL}/topics/icons`,
  uploadTopicIcon: (topicId: number) => `${baseURL}/topics/${topicId}/icon`,
  deleteTopicIcon: (topicId: number) => `${baseURL}/topics/${topicId}/icon`,
  uploadPendingTopicChildrenIcon: `${baseURL}/topics/icons/children`,
  uploadTopicChildrenIcon: (topicId: number) =>
    `${baseURL}/topics/${topicId}/children-icon`,
  deleteTopicChildrenIcon: (topicId: number) =>
    `${baseURL}/topics/${topicId}/children-icon`,
};

export const AdminAPI = {
  getAllCategoriesTopics: `${baseURL}/categories-topics/view`,
  getAllParkingPlaces: `${baseURL}/parking-spaces`,
  putUpdateParkingPlaces: (parkingSpaceId: number) =>
    `${baseURL}/parking-spaces/${parkingSpaceId}`,
  getAllEmployees: `${baseURL}/users/view`,
  getAllSystemTopics: `${baseURL}/topics`,
  postNewUser: `${baseURL}/users`,
  putUserStatus: (userId: number) => `${baseURL}/users/${userId}/activate`,
  deleteUser: (userId: number) => `${baseURL}/users/${userId}`,
  putUserTopic: (roleId: number) => `${baseURL}/users/roles/${roleId}`,
  putUserData: (userId: number) => `${baseURL}/users/${userId}`,
  getUserBranches: (userId: number) => `${baseURL}/users/${userId}/branches`,
  getUserQueues: (userId: number) => `${baseURL}/users/${userId}/queues`,
  putUserQueues: (userId: number) => `${baseURL}/users/${userId}/queues`,
  uploadUserPhoto: (userId: number) => `${baseURL}/users/${userId}/photo`,
  deleteUserPhoto: (userId: number) => `${baseURL}/users/${userId}/photo`,
};

export const WorkingPlacesTableAPI = {
  getAllWorkingPlaces: `${baseURL}/service-units/work-places`,
  getRolesAndEmplouees: `${baseURL}/users/work-place-info`,
  postCreateWorkingPlace: `${baseURL}/service-units`,
  putUpdateWorkingPlace: (workingPlaceId: number) =>
    `${baseURL}/service-units/${workingPlaceId}`,
  deleteWorkingPlace: (workingPlaceId: number) =>
    `${baseURL}/service-units/${workingPlaceId}`,
  putWorkingPlaceStatus: (workingPlaceId: number) =>
    `${baseURL}/service-units/${workingPlaceId}/activate`,
};

export const AdminAnalyticsAndReportsAPI = {
  getCurrentServicesStatusEmployees: `${baseURL}/reports/client-service-employee`,
  getCurrentServicesStatusQueue: `${baseURL}/reports/client-service-queue`,
  getStationReportToday: `${baseURL}/reports/station-today`,
  getStationReportPeriod: `${baseURL}/reports/station-period`,
  getClientReportToday: `${baseURL}/reports/client-today`,
  getClientReportPeriod: `${baseURL}/reports/client-period`,
  getContainersReport: `${baseURL}/reports/container`,
  getServicesReport: `${baseURL}/reports/service`,
  getEmployeesReport: `${baseURL}/reports/worker`,
  getCarNumbersReport: `${baseURL}/reports/car-number`,
  getVisitorsReport: `${baseURL}/reports/client`,
  getQualityReport: `${baseURL}/reports/quality`,
};

export const AdvertisingAPI = {
  getAllSettings: `${baseURL}/content/view`,
  getAllVideos: `${baseURL}/content/video`,
  getAllTickers: `${baseURL}/content/tickers`,
  postVideo: `${baseURL}/content/video/upload`,
  postTicker: `${baseURL}/content/tickers`,
  putTicker: (tickerId: number) => `${baseURL}/content/tickers/${tickerId}`,
  putHeaders: `${baseURL}/content/texts`,
  putPlaylist: `${baseURL}/content/playlists`,
  deleteTicker: (tickerId: number) => `${baseURL}/content/tickers/${tickerId}`,
  deleteVideo: (videoId: number) => `${baseURL}/content/video/${videoId}`,
  activateContent: (contentId: number) =>
    `${baseURL}/content/${contentId}/activate`,
};

export const RatingAPI = {
  getState: `${baseURL}/rating/state`,
  save: `${baseURL}/rating/save`,
  getSettings: (branchQueueId: number) =>
    `${baseURL}/rating/settings/${branchQueueId}`,
  updateSettings: (branchQueueId: number) =>
    `${baseURL}/rating/settings/${branchQueueId}`,
  uploadMedia: (branchQueueId: number) =>
    `${baseURL}/rating/settings/${branchQueueId}/media`,
  deleteMedia: (branchQueueId: number, mediaId: number) =>
    `${baseURL}/rating/settings/${branchQueueId}/media/${mediaId}`,
};

export const TerminalAppearanceAPI = {
  getAppearance: `${baseURL}/terminal-appearance`,
  updateAppearance: `${baseURL}/terminal-appearance`,
  resetAppearance: `${baseURL}/terminal-appearance/reset`,
  uploadBackground: `${baseURL}/terminal-appearance/background`,
  uploadChildrenBackground: `${baseURL}/terminal-appearance/background/children`,
  uploadOuterCircleSmall: `${baseURL}/terminal-appearance/buttons/outer-circle-small`,
  uploadSectionOuterCircleSmall: `${baseURL}/terminal-appearance/buttons/section-outer-circle-small`,
  uploadLogo: `${baseURL}/terminal-appearance/logo`,
  uploadTabloLogo: `${baseURL}/terminal-appearance/tablo/logo`,
  uploadTabloSliderImage: `${baseURL}/terminal-appearance/tablo/slider/images`,
  uploadTabloVideo: `${baseURL}/terminal-appearance/tablo/video`,
  deleteBackground: (backgroundId: number) =>
    `${baseURL}/terminal-appearance/background/${backgroundId}`,
  deleteChildrenBackground: (backgroundId: number) =>
    `${baseURL}/terminal-appearance/background/children/${backgroundId}`,
  uploadTicketPicture: `${baseURL}/terminal-appearance/ticket-pictures`,
  deleteTicketPicture: (pictureId: number) =>
    `${baseURL}/terminal-appearance/ticket-pictures/${pictureId}`,
  uploadTicketLayoutImage: `${baseURL}/terminal-appearance/ticket-layout-images`,
  deleteTicketLayoutImage: (imageId: number) =>
    `${baseURL}/terminal-appearance/ticket-layout-images/${imageId}`,
  getBeltaRss: (limit: number) =>
    `${baseURL}/terminal-appearance/rss/belta?limit=${limit}`,
};

export const LicenseAPI = {
  allLicenses: `${baseURL}/license`,
  currentLicense: `${baseURL}/license/active`,
  addLicense: `${baseURL}/license`,
};

export const UserPermissionsAPI = {
  getMyPermissions: `${baseURL}/user-permissions/me`,
  getPermissionsForUser: (userId: number) =>
    `${baseURL}/user-permissions/users/${userId}`,
  putPermissionsForUser: (userId: number) =>
    `${baseURL}/user-permissions/users/${userId}`,
};

export const BranchAPI = {
  getAll: `${baseURL}/branches`,
  create: `${baseURL}/branches`,
  getQueuesForCurrentUser: `${baseURL}/branches/queues/for-current-user`,
  getQueues: (branchId: number) => `${baseURL}/branches/${branchId}/queues`,
  createQueue: (branchId: number) => `${baseURL}/branches/${branchId}/queues`,
  update: (branchId: number) => `${baseURL}/branches/${branchId}`,
  delete: (branchId: number) => `${baseURL}/branches/${branchId}`,
  updateQueue: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}`,
  deleteQueue: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}`,
  queueLinks: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/links`,
  addQueueMonitor: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitors`,
  updateQueueMonitor: (branchId: number, queueId: number, monitorId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitors/${monitorId}`,
  deleteQueueMonitor: (branchId: number, queueId: number, monitorId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitors/${monitorId}`,
  addQueueTerminal: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminals`,
  updateTerminalIp: (branchId: number, queueId: number, orderUnitId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminals/${orderUnitId}`,
  deleteQueueTerminal: (
    branchId: number,
    queueId: number,
    orderUnitId: number,
  ) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminals/${orderUnitId}`,
  getQueueCategories: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/categories`,
  setQueueCategories: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/categories`,
  getQueueTopics: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/topics`,
  setQueueTopics: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/topics`,
  /**
   * Привязка тем услуг к терминалам очереди (по аналогии с monitor-topics).
   * Ожидается, что бэкенд поддерживает эти эндпоинты.
   */
  getQueueTerminalTopics: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminal-topics`,
  setQueueTerminalTopics: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminal-topics`,
  getQueueTerminalTopicsByTerminal: (
    branchId: number,
    queueId: number,
    orderUnitId: number,
  ) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminals/${orderUnitId}/terminal-topics`,
  setQueueTerminalTopicsByTerminal: (
    branchId: number,
    queueId: number,
    orderUnitId: number,
  ) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminals/${orderUnitId}/terminal-topics`,
  setQueueTerminalTopicsAll: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/terminal-topics/all`,
  getQueueServiceUnits: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/service-units`,
  getQueueMonitors: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitors`,
  getQueueMonitorTopics: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitor-topics`,
  getQueueMonitorTopicsByMonitor: (
    branchId: number,
    queueId: number,
    monitorId: number,
  ) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitors/${monitorId}/monitor-topics`,
  setQueueMonitorTopics: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitor-topics`,
  setQueueMonitorTopicsByMonitor: (
    branchId: number,
    queueId: number,
    monitorId: number,
  ) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitors/${monitorId}/monitor-topics`,
  setQueueMonitorTopicsAll: (branchId: number, queueId: number) =>
    `${baseURL}/branches/${branchId}/queues/${queueId}/monitor-topics/all`,
};
